/* Craftly BOGO 2+1 cart progress bar + Subscription Discount Auto-Removal */

// === Subscription Discount Auto-Removal ===
// If user has 20% discount (MNUI_SUB_20) but removed the hidden club from cart,
// silently clear the discount via cart update.
(function watchSubscriptionDiscount(){
  if (window.__craftlySubWatch) return;
  window.__craftlySubWatch = true;

  var HIDDEN_CLUB = 8028290777187;
  var lastCheck = 0;

  function checkClubRemoval(){
    var now = Date.now();
    if (now - lastCheck < 500) return;
    lastCheck = now;
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var hasClub = (cart.items || []).some(function(it){ return it.product_id === HIDDEN_CLUB; });
        var totalDisc = cart.total_discount || 0;
        var hasMnui = (cart.discount_codes || []).some(function(d){ return (d.code || '').indexOf('MNUI') >= 0; });
        if (!hasClub && (totalDisc > 0 || hasMnui)) {
          // Club removed but discount still active - clear it via Shopify cart update
          fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: '' })
          }).then(function(){
            // Trigger UI refresh
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            window.dispatchEvent(new CustomEvent('cart:refresh'));
          }).catch(function(){});
        }
      })
      .catch(function(){});
  }

  ['cart:refresh','cart:item-removed','cart:updated','cart:build','on:cart:updated','cart:item-added'].forEach(function(name){
    document.addEventListener(name, function(){ setTimeout(checkClubRemoval, 350); });
  });
})();

(function(){
  if (window.customElements && window.customElements.get('craftly-bogo-bar')) return;

  class CraftlyBogoBar extends HTMLElement {
    connectedCallback(){
      if (this._init) return;
      this._init = true;
      this.card = this.querySelector('[data-cbb-card]');
      this.msgEl = this.querySelector('[data-cbb-msg]');
      this.iconEl = this.querySelector('[data-cbb-icon]');
      this.fillEl = this.querySelector('[data-cbb-fill]');
      this.statsEl = this.querySelector('[data-cbb-stats]');
      if (!this.card || !this.msgEl || !this.fillEl) return;
      this.excludedProducts = (this.dataset.excludedProducts || '').split(',')
        .map(function(s){ return parseInt(s, 10); })
        .filter(function(n){ return !isNaN(n); });
      this.render(parseInt(this.dataset.count, 10) || 0);
      this._onUpdate = this.refreshFromAPI.bind(this);
      var ev = ['cart:refresh','cart:item-added','on:cart:added','cart:build','cart:updated','product:added'];
      var self = this;
      ev.forEach(function(n){ document.addEventListener(n, self._onUpdate); });
      // Also refresh after a tick in case the drawer was just re-rendered with stale count
      setTimeout(this._onUpdate, 50);
    }
    disconnectedCallback(){
      if (!this._onUpdate) return;
      var self = this;
      ['cart:refresh','cart:item-added','on:cart:added','cart:build','cart:updated','product:added']
        .forEach(function(n){ document.removeEventListener(n, self._onUpdate); });
    }
    computeFromCart(cart){
      var count = 0;
      var ex = this.excludedProducts;
      (cart.items || []).forEach(function(it){
        if (ex.indexOf(it.product_id) >= 0) return;
        if (it.selling_plan_allocation) return;
        count += it.quantity;
      });
      return count;
    }
    refreshFromAPI(){
      var self = this;
      fetch('/cart.js')
        .then(function(r){ return r.json(); })
        .then(function(cart){ self.render(self.computeFromCart(cart)); })
        .catch(function(){});
    }
    render(count){
      if (count <= 0){
        this.hidden = true;
        this.dataset.count = '0';
        return;
      }
      this.hidden = false;
      this.dataset.count = count;

      var inCycle = count % 3;
      var completed = Math.floor(count / 3);
      var msg = '', pct = 0, icon = '🎁', isComplete = false, stats = '';

      if (inCycle === 0){
        msg = '🎉 קיבלתם <strong>' + completed + ' ' + (completed === 1 ? 'מתנה' : 'מתנות') + '</strong>! המתנה תרד בקופה.';
        pct = 100; icon = '🎉'; isComplete = true;
        stats = completed + ' במתנה • הוסיפו עוד 3 לעוד מתנה';
      } else if (inCycle === 2){
        msg = 'הוסיפו עוד <strong>1 בחינם</strong>!';
        pct = 66.6; icon = '✨';
        stats = completed > 0
          ? (completed + ' מתנות בעגלה • עוד 1 למתנה נוספת')
          : (count + ' בעגלה • עוד 1 למתנה');
      } else if (inCycle === 1){
        msg = 'הוסיפו עוד <strong>2</strong> ותקבלו <strong>1 חינם</strong>!';
        pct = 33.3; icon = '🎁';
        stats = completed > 0
          ? (completed + ' מתנות בעגלה • עוד 2 למתנה נוספת')
          : (count + ' בעגלה • עוד 2 למתנה');
      }

      this.msgEl.innerHTML = msg;
      this.fillEl.style.width = pct + '%';
      this.iconEl.textContent = icon;
      this.statsEl.textContent = stats;
      this.card.classList.toggle('is-complete', isComplete);
    }
  }

  customElements.define('craftly-bogo-bar', CraftlyBogoBar);
})();
